import React from 'react'
import { IconButton } from 'shared/ui'

const DeleteButton = React.memo(({ deleteConversation, isExpired = false }) => {
  return (
    <div className="delete">
      <IconButton
        name="delete"
        size="medium"
        className="menu-button"
        disabled={isExpired}
        onClick={deleteConversation}
        tooltip={
          !isExpired
            ? 'Move to Trash'
            : "Can't Move to Trash an expired conversation"
        }
        svg
      />
    </div>
  )
})

export default DeleteButton
